import OperationAreaRequestModelBase from '../_generated/modelBases/operation-area-request-model-base';

export default class OperationAreaRequestModel extends OperationAreaRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
